module.exports = __webpack_public_path__ + "4c27b37edc1119b2c50099eb60723afd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-coin.png
// module id = 1881
// module chunks = 0